import React, {useState} from "react";
import Table from "../../../components/Table/Table";
import SearchTicketModal from "../../../components/SearchTicketModal/SearchTicketModal";
import FilterTechnicianClientsModal
    from "../../../components/FilterTechnicianClientsModal/FilterTechnicianClientsModal";
import {useGetTechnicianTickets} from "../../../hooks/Technician/useGetTechnicianTickets";
import TechnicianTicketInfo from "../../../components/TechnicianTicketInfo/TechnicianTicketInfo";

const columns = ['CLIENTE', 'PLANTA', 'SERVICIO', 'ESTADO', 'CLAVE DE TICKET'];

const TechnicianTickets = () => {

    const [filters, setFilters] = useState({});
    const {tickets, totalPages, isLoading, page, setPage} = useGetTechnicianTickets({filters});

    const [isSearchModalVisible, setSearchModalVisible] = useState(false);
    const [isFilterModalVisible, setFilterModalVisible] = useState(false);

    const [selectedTicket, setSelectedTicket] = useState<string>('');
    const [showTicketInfo, setShowTicketInfo] = useState<boolean>(false);

    const [additionalInfo, setAdditionalInfo] = useState<any>(null);

    const handleResetTechniciansTable = () => {
        setFilters({});
        setPage(0);
    };

    const handleSearchModal = (uniqueCode: string) => {
        setFilters({uniqueCode});
    };

    const handleFilterModal = (newFilters: object) => {
        setFilters(newFilters);
        setPage(0);
    };

    const handleOnRowClick = (row: Record<string, any>) => {
        setSelectedTicket(row['CLAVE DE TICKET']);
        setAdditionalInfo(row);
        setShowTicketInfo(true);

    };

    const handleBack = () => {
        setShowTicketInfo(false);
    };

    const changeAdditionalInfoTicketState = (newState: string) => {
        additionalInfo['ESTADO'] = newState;
    }

    return (
        <div className="clients-view-container">
            {showTicketInfo ? (
                <TechnicianTicketInfo additionalInfo={additionalInfo} ticketCode={selectedTicket} onBack={handleBack}
                                      showTicketInfo={setShowTicketInfo}
                                      updateTicketStateLocally={changeAdditionalInfoTicketState}/>
            ) : isLoading ? (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                    <div className="loading-message">Obteniendo información...</div>
                </div>
            ) : (
                <div className="clients-view-table">
                    <div className="clients-view-header">
                        <div className="clients-view-header-title">
                            <p>TICKETS</p>
                        </div>
                        <span className="material-icons-outlined icon-unselected"
                              onClick={() => setSearchModalVisible(true)}>
                    search
                </span>
                        <span className="material-icons-outlined icon-unselected"
                              onClick={() => setFilterModalVisible(true)}>
                    filter_alt
                </span>
                        <span className="material-icons-outlined icon-unselected" onClick={handleResetTechniciansTable}>
                    restart_alt
                </span>
                    </div>
                    <Table
                        columns={columns}
                        data={tickets}
                        totalPages={totalPages}
                        currentPage={page}
                        setCurrentPage={setPage}
                        onRowClick={handleOnRowClick}
                    />
                </div>
            )}

            <SearchTicketModal
                isVisible={isSearchModalVisible}
                onClose={() => setSearchModalVisible(false)}
                onSearch={handleSearchModal}
                placeholder="Clave de ticket"
            />
            <FilterTechnicianClientsModal
                isVisible={isFilterModalVisible}
                onClose={() => setFilterModalVisible(false)}
                onSearch={handleFilterModal}
                services={["Preventivo", "Correctivo", "Instalación", "Verificación"]}
                states={["Asignado", "En progreso", "Bloqueado", "En revisión"]}
            />
        </div>
    );
}

export default TechnicianTickets;